import { GetterTree } from "vuex";
import { RootState } from "@/store/types";
import { WebhooksState } from "../types";

const getters: GetterTree<WebhooksState, RootState> = {
  getCurrentWebhook: (state) => state.currentWebhook,
  getAllWebhooks: (state) => state.webhooks,
  getCurrentWebhookAttempts: (state) => state.currentWebhookAttempts,
  getTotalFailedAttempts: (state) => state.totalAttempts,
  getTotalSuceededAttempts: (state) => state.totalSucceededAttempts,
  getTotalAttempts: (state) => state.totalFailedAttempts,
  isViewing: (state) => state.viewing,
};

export default getters;
